import { useEffect } from "react";

interface DownloadModalProps {
  open: boolean;
  title: string;
  desc: string;
  onClose: () => void;
}

export default function DownloadModal({ open, title, desc, onClose }: DownloadModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭弹层"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/60 cursor-pointer"
      />
      <div className="relative w-full max-w-md overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex items-start justify-between gap-4 border-b border-background-200 px-6 py-5">
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className="ri-folder-download-line text-xl"></i>
            </span>
            <h2 className="text-base font-semibold text-foreground-950">{title}</h2>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 flex-none items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>

        <div className="px-6 py-5">
          <p className="text-sm leading-relaxed text-foreground-600">{desc}</p>
          <ul className="mt-5 space-y-2 border-t border-background-200 pt-4 text-sm text-foreground-700">
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-600"></i>
              来源与抓取时间标注
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-600"></i>
              原始片段与整理结果对照
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-checkbox-circle-line text-secondary-600"></i>
              按主题分类的索引结构
            </li>
          </ul>
          <p className="mt-5 rounded-md bg-accent-100/80 px-4 py-3 text-xs leading-relaxed text-accent-900">
            本页为静态展示，资料入口仅示意结构，不提供真实文件传输。
          </p>
        </div>

        <div className="flex flex-col gap-2 border-t border-background-200 px-6 py-5 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
          >
            关闭
          </button>
          <button
            type="button"
            onClick={onClose}
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}